import {
  instance as axios,
  setJwtToken,
  // setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------category-listing--------------------------
export const outOfStockListApi = async (data) => {
  const endPoint = `/admin/product/outof/stock?${new URLSearchParams({ ...data, })}`;
  return await axios.get(endPoint, setJwtToken());
};
